import React, { Component } from 'react'
import NoteForm from './NoteForm'
import DecryptPasswordForm from '../containers/DecryptPasswordForm'
import { withRouter, Link } from 'react-router-dom'
import Toolbar, { ToolbarButton } from './Toolbar'
import Card, { CardContent } from 'material-ui/Card'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'
import { MaxWidthContainer } from '../helpers/layout'
import { EditorState } from 'draft-js'
import { stateToHTML } from 'draft-js-export-html'
import { stateFromHTML } from 'draft-js-import-html'
import BackIcon from 'material-ui-icons/KeyboardArrowLeft'
import DeleteIcon from 'material-ui-icons/Delete'

const styles = theme => ({
  noteCard: {
    marginLeft: 2 * theme.spacing.unit,
    marginRight: 2 * theme.spacing.unit,
    marginBottom: 2 * theme.spacing.unit
  },
  decryptPasswordCard: {
    marginLeft: 2 * theme.spacing.unit,
    marginRight: 2 * theme.spacing.unit,
    marginBottom: 2 * theme.spacing.unit
  }
})

class NoteEditionPage extends Component {
  constructor(props) {
    super(props)
    this.componentIsMounted = false
    this.state = { editorState: null, toolbar: null }
    this.handleNewProps(this.props)
  }
  componentWillMount() {
    this.componentIsMounted = true
  }
  componentWillUnmount() {
    this.componentIsMounted = false
  }
  componentWillUpdate(newProps) {
    this.handleNewProps(newProps)
  }
  handleNewProps(props) {
    if (props.deletedNoteId) {
      props.history.push('/notes')
      props.resetDeletedNoteId()
    } else {
      const { noteId: pathNoteId } = props.match.params
      const { noteId, note } = props
      if (!note || noteId !== pathNoteId) {
        this.props.selectNote(pathNoteId)
      } else if (!this.state.editorState) {
        if (this.componentIsMounted) {
          this.setState({
            editorState: EditorState.createWithContent(
              stateFromHTML(props.note.content)
            )
          })
        }
      }
    }
  }
  handleSubmit({ title }) {
    const editorState = this.state.editorState
    const contentState = editorState.getCurrentContent()
    const content = stateToHTML(contentState)
    this.props.updateNote({
      noteId: this.props.noteId,
      title,
      content,
      userId: this.props.user.uid
    })
  }
  handleEditorChange(editorState) {
    this.setState({ editorState })
  }
  renderNote() {
    const { noteId: pathNoteId } = this.props.match.params
    const { classes, noteId, note } = this.props
    const noteIsLoaded = note && noteId === pathNoteId
    return noteIsLoaded ? (
      <Card className={classes.noteCard}>
        <CardContent>
          {this.state.editorState &&
            this.state.toolbar && (
              <NoteForm
                initialValues={note}
                onSubmit={values => this.handleSubmit(values)}
                editorState={this.state.editorState}
                onEditorChange={editorState =>
                  this.handleEditorChange(editorState)}
                toolbar={this.state.toolbar}
              />
            )}
        </CardContent>
      </Card>
    ) : (
      <div>Loading…</div>
    )
  }
  setRef = element => {
    this.setState({ toolbar: element })
  }
  render() {
    const { classes } = this.props
    return (
      <div>
        <Toolbar ref={this.setRef}>
          <ToolbarButton icon color="primary" component={Link} to="/notes">
            <BackIcon />
          </ToolbarButton>
          <ToolbarButton
            icon
            floatRight
            color="default"
            onClick={() =>
              this.props.deleteNote({
                userId: this.props.user.uid,
                noteId: this.props.match.params.noteId
              })}
          >
            <DeleteIcon />
          </ToolbarButton>
        </Toolbar>
        {this.props.keyPassword ? (
          this.renderNote()
        ) : (
          <MaxWidthContainer>
            <Card className={classes.decryptPasswordCard}>
              <CardContent>
                <Typography type="body1">
                  To display the note content please unlock your key by entering
                  your key password.
                </Typography>
                <DecryptPasswordForm />
              </CardContent>
            </Card>
          </MaxWidthContainer>
        )}
      </div>
    )
  }
}

export default withStyles(styles)(withRouter(NoteEditionPage))



// WEBPACK FOOTER //
// ./src/components/NoteEditionPage.js